if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.normalizeRegionPicker();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      normalizeRegionPicker() {
        const countryInput = this.querySelector('input[name="country_code"]');
        const countryList = this.querySelector('.country-selector__list');
        if (!countryInput || !countryList) return;

        const euCodes = [
          'AT',
          'BE',
          'BG',
          'HR',
          'CY',
          'CZ',
          'DE',
          'DK',
          'EE',
          'FI',
          'FR',
          'GR',
          'HU',
          'IE',
          'IT',
          'LT',
          'LU',
          'LV',
          'MT',
          'NL',
          'PL',
          'PT',
          'RO',
          'SK',
          'SI',
          'ES',
          'SE',
        ];
        const currentCode = countryInput.value;
        const buttonLabel = this.querySelector('button.localization-form__select > span');
        const currentButtonText = buttonLabel ? buttonLabel.textContent.replace(/\s+/g, ' ').trim() : '';
        const currentCurrencyText = currentButtonText.includes('|')
          ? currentButtonText.split('|').slice(1).join('|').trim()
          : '';
        const isCurrentGb = currentCode === 'GB' || currentCurrencyText.includes('GBP');
        const isCurrentEu = euCodes.includes(currentCode) || currentCurrencyText.includes('EUR');
        const currentRegion = isCurrentGb ? 'United Kingdom' : isCurrentEu ? 'European Union' : 'United States';

        if (buttonLabel) {
          buttonLabel.textContent = currentCurrencyText ? `${currentRegion} | ${currentCurrencyText}` : currentRegion;
        }

        const countryLinks = Array.from(this.querySelectorAll('a[data-value]'));
        const getCountryValue = (code) => {
          const match = countryLinks.find((link) => link.dataset.value === code);
          return match ? match.dataset.value : '';
        };
        const usValue = getCountryValue('US') || 'US';
        const euCountryLink = countryLinks.find((link) => euCodes.includes(link.dataset.value));
        const euValue = getCountryValue('DE') || (euCountryLink ? euCountryLink.dataset.value : '') || 'DE';
        const gbValue = getCountryValue('GB');
        const checkmarkElement = this.querySelector('.icon-checkmark');
        const checkmark = checkmarkElement ? checkmarkElement.outerHTML : '';

        const buildRegionItem = ({ id, label, value, active, disabled }) => {
          const currentAttribute = active ? ' aria-current="true"' : '';
          const valueAttribute = value ? ` data-value="${value}"` : '';
          const disabledAttributes = disabled
            ? ' aria-disabled="true" data-disabled="true" tabindex="-1" style="opacity: .45; cursor: not-allowed;"'
            : '';
          const disabledClass = disabled ? ' localization-region__link--disabled' : '';
          const checkmarkClass = active ? '' : ' class="visibility-hidden"';

          return `
            <li class="disclosure__item" tabindex="-1">
              <a
                class="link link--text disclosure__link caption-large focus-inset localization-region__link${disabledClass}"
                href="#"
                id="${id}"
                ${currentAttribute}
                ${valueAttribute}
                ${disabledAttributes}
              >
                <span${checkmarkClass}>${checkmark}</span>
                <span class="country">${label}</span>
              </a>
            </li>
          `;
        };

        const filter = this.querySelector('.country-filter');
        if (filter) {
          filter.classList.add('country-filter--no-padding');
          Array.from(filter.children).forEach((child) => {
            if (!child.classList.contains('country-selector__close-button')) {
              child.remove();
            }
          });
        }

        countryList.classList.remove('country-selector__list--with-multiple-currencies');
        countryList.classList.add('localization-region__list');
        countryList.innerHTML = `
          <ul role="list" class="list-unstyled countries">
            ${buildRegionItem({
              id: `${countryList.id || 'Country'}-region-us`,
              label: 'United States',
              value: usValue,
              active: currentRegion === 'United States',
              disabled: false,
            })}
            ${buildRegionItem({
              id: `${countryList.id || 'Country'}-region-eu`,
              label: 'European Union',
              value: euValue,
              active: currentRegion === 'European Union',
              disabled: false,
            })}
            ${buildRegionItem({
              id: `${countryList.id || 'Country'}-region-gb`,
              label: 'United Kingdom',
              value: gbValue,
              active: currentRegion === 'United Kingdom',
              disabled: !gbValue,
            })}
          </ul>
        `;
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) =>
            !item.parentElement.classList.contains('hidden') &&
            item.dataset.disabled !== 'true' &&
            item.getAttribute('aria-disabled') !== 'true'
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        if (
          event.currentTarget.dataset.disabled === 'true' ||
          event.currentTarget.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
